import React from 'react'
import PropTypes from 'prop-types'
import { findLastIndex } from 'lodash'
import { connect } from 'react-redux'

import { Info } from 'react-wot-bootstrap'

import WGCWXShopProductCard from '../WGCWXShopCard/WGCWXShopProductCard'
import FamePoints from 'components/FamePoints/FamePoints'
import { getGroupsType, isCnRealm } from 'containers/WGCWXShop/helpers'

import {
    PREMIUM_BONUSES_NOT_AVAILABLE_YET,
    GROUP_CAPTIONS,
} from 'containers/WGCWXShop/translations'
import {
    PFP_BATTLES_BONUS_SECTION,
    PREMIUM_BONUSES_SECTION,
    PRICE_STARTS_FROM,
} from '../../translations'
import {
    PRODUCTS_CONFIG,
    PRODUCTS_GRID_CONFIG,
    PRODUCTS_GRID_CONFIG_CN,
    PRODUCTS_SIZE_CONFIG,
} from 'containers/WGCWXShop/products.config'
import { PRODUCT_TYPES, GROUP_TYPES } from 'containers/WGCWXShop/constants'
import { ProductPropTypes } from 'containers/WGCWXShop/propTypes'

import styles from '../../WGCWXShopProducts.scss'

export class WGCWXShopProductGrid extends React.Component {
    static propTypes = {
        products: PropTypes.objectOf(ProductPropTypes).isRequired,
        accountFamePoints: PropTypes.number,
        realm: PropTypes.string.isRequired,

        selectProduct: PropTypes.func.isRequired,
    }

    selectProduct = type => e => this.props.selectProduct(type)

    getGroups(product) {
        return Object.entries(product.groups)
    }

    getCurrentGroup(product) {
        const groupKeys = Object.keys(product.groups)
        return groupKeys[0].split(':')[1]
    }

    translateGroup = (group) => {
        if (group) {
            return <span>{': '}{GROUP_CAPTIONS[group]}</span>
        }
    }

    getLastIndex(item) {
        return findLastIndex(item[1], i => i.is_bought) + 1
    }

    renderGrid() {
        const { realm } = this.props
        const gridConfig = isCnRealm(realm) ? PRODUCTS_GRID_CONFIG_CN : PRODUCTS_GRID_CONFIG
        return gridConfig.map((row, index) => {
            return (
                <div
                    key={`row-${index}`}
                    className={styles.grid_row}
                >
                    {row.map(item => this.renderCard(PRODUCT_TYPES[item], PRODUCTS_SIZE_CONFIG[row.length - 1]))}
                </div>
            )
        })
    }

    renderCard(productType, size) {
        const product = this.props.products[productType]
        if (!product) return null
        const groups = this.getGroups(product)
        const groupsType = getGroupsType(product)
        const currentGroup = this.getCurrentGroup(product)
        const hasOneGroup = (groups.length === 1) && (groupsType !== GROUP_TYPES.root)

        const firstGroup = Object.entries(product.groups)[0]

        const availableAmount = groups
            .map(item => item[1].length)
            .reduce((sum, current) => sum + current )

        const items = firstGroup[1]
        const boughtItemsNumber = groups
            .map(item => this.getLastIndex(item))
            .reduce((sum, current) => sum + current )

        const currentItem = items.find(item => !item.is_bought)
        const titleItem = currentItem || items[items.length - 1]

        const itemConfig = PRODUCTS_CONFIG[productType](titleItem)

        const minPriceItemsArr = groups
            .map(item => item[1][this.getLastIndex(item)])
            .filter(item => item !== undefined)

        let minBoughtItemsPrice = null

        if (minPriceItemsArr.length !== 0) {
            minBoughtItemsPrice = minPriceItemsArr
                .reduce((min, item) => min < item.price ? min : item.price, minPriceItemsArr[0].price)
        }

        const { accountFamePoints } = this.props

        const priceNotAvailable = (
            minBoughtItemsPrice &&
            accountFamePoints !== null &&
            accountFamePoints < minBoughtItemsPrice
        )

        let price = null
        if (
            minBoughtItemsPrice !== null &&
            boughtItemsNumber !== availableAmount
        ) {
            const isLastItemLeft = boughtItemsNumber === availableAmount - 1
            price = isLastItemLeft ?
                <FamePoints size="medium" value={minBoughtItemsPrice} notAvailable={priceNotAvailable} /> :
                PRICE_STARTS_FROM(
                    <FamePoints size="medium" value={minBoughtItemsPrice} notAvailable={priceNotAvailable}/>
                )
        }

        const isAvailable = product.is_available_to_buy && boughtItemsNumber !== availableAmount
        return (
            <WGCWXShopProductCard
                key={productType}
                title={itemConfig.title}
                groupName={hasOneGroup ? this.translateGroup(currentGroup) : undefined}
                description={itemConfig.description}
                price={price}
                boughtAmount={boughtItemsNumber}
                availableAmount={availableAmount}
                productType={productType}
                value={currentItem ? currentItem.value : titleItem.value}
                size={size}
                isAvailable={isAvailable}
                realm={this.props.realm}
                onClick={this.selectProduct(productType)}
            />
        )
    }

    renderPfpBonuses() {
        if (!this.props.products.PFP_BATTLES) return null
        return (
            <section>
                <h2 className={styles.subtitle}>
                    {PFP_BATTLES_BONUS_SECTION}
                </h2>
                <div className={styles.grid_row}>
                    {this.renderCard(PRODUCT_TYPES.PFP_BATTLES, 'large')}
                </div>
            </section>
        )
    }

    renderPremiumBonuses() {
        const availableProducts = Object.keys(this.props.products)
        if (
            availableProducts.length === 0 ||
            availableProducts.length === 1 && availableProducts[0] === PRODUCT_TYPES.PFP_BATTLES
        ) return null

        return (
            <section>
                {this.props.products.PFP_BATTLES && (
                    <div>
                        <h2 className={styles.subtitle}>
                            {PREMIUM_BONUSES_SECTION}
                        </h2>
                        <div className={styles.info}>
                            <Info />
                            &nbsp;
                            {PREMIUM_BONUSES_NOT_AVAILABLE_YET}
                        </div>
                    </div>
                )}
                {this.renderGrid()}
            </section>
        )
    }

    render() {
        return (
            <div className={styles.grid}>
                {this.renderPfpBonuses()}
                {this.renderPremiumBonuses()}
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        realm: state.settings.realm,
    }
}

export default connect(mapStateToProps)(WGCWXShopProductGrid)



// WEBPACK FOOTER //
// ./containers/WGCWXShop/containers/WGCWXShopProducts/components/WGCWXShopProductGrid/WGCWXShopProductGrid.jsx